import { load } from './util';

$(document).on('change', '[data-statistics-subtypes]', function(event) {
  event.preventDefault();
  const url = this.options[this.selectedIndex].getAttribute('data-href');
  const $content = $(this).closest('[data-statistics-content]');

  const promise = $.ajax({
    url,
    method: 'GET',
  }).then((data) => {
    $content.replaceWith(data);
  });

  load($content, promise);
});

$(document).on('submit', '[data-statistics-filter]', function(event) {
  event.preventDefault();
  const $form = $(this);
  const $content = $form.closest('[data-statistics-content]');

  const promise = $.ajax({
    url: $form.attr('action'),
    method: $form.attr('method'),
    data: $form.serializeArray(),
  }).then((data) => {
    $content.replaceWith(data);
  });

  load($content, promise);
});
